"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var antd_1 = require("antd");
var react_linkify_1 = tslib_1.__importDefault(require("react-linkify"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var StyledText = (0, styled_components_1.default)(antd_1.Typography.Text)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) { return props.color || undefined; });
var Group = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin: 0 !important;\n\n  .canCopy {\n    width: calc(100% - 15px);\n\n    :hover + .copy-icon {\n      visibility: visible;\n    }\n  }\n\n  .copy-icon {\n    cursor: pointer;\n    visibility: hidden;\n\n    :hover {\n      color: #0044ff;\n      visibility: visible;\n    }\n  }\n"], ["\n  margin: 0 !important;\n\n  .canCopy {\n    width: calc(100% - 15px);\n\n    :hover + .copy-icon {\n      visibility: visible;\n    }\n  }\n\n  .copy-icon {\n    cursor: pointer;\n    visibility: hidden;\n\n    :hover {\n      color: #0044ff;\n      visibility: visible;\n    }\n  }\n"])));
var TruncatedText = function (_a) {
    var value = _a.value, canCopy = _a.canCopy, type = _a.type, strong = _a.strong, className = _a.className, color = _a.color;
    var _b = (0, react_1.useState)(false), truncated = _b[0], setTruncated = _b[1];
    if (!value) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var str = value.toString();
    return (react_1.default.createElement(antd_1.Tooltip, { title: truncated ? react_1.default.createElement(react_linkify_1.default, null, str) : "", overlayStyle: { maxWidth: "500px" } },
        react_1.default.createElement(Group, null,
            react_1.default.createElement(StyledText, { ellipsis: {
                    onEllipsis: function (v) {
                        setTruncated(v);
                    },
                }, type: type, strong: strong, color: color },
                canCopy && react_1.default.createElement(StyledText, { className: canCopy ? "canCopy ".concat(className) : "", copyable: canCopy }),
                " ",
                str))));
};
exports.default = TruncatedText;
var templateObject_1, templateObject_2;
//# sourceMappingURL=text.js.map